import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/shared/components/shadcn/table';
import { formatNumber } from '@/shared/utils/format-number';

interface EngagementMetricsProps {
  totalEngagements: number;
  totalLikes: number;
  totalComments: number;
  totalShares: number;
}

export function EngagementMetrics({
  totalEngagements,
  totalLikes,
  totalComments,
  totalShares,
}: EngagementMetricsProps) {
  const gridTemplateColumns = `auto 124px`;

  const metrics = [
    { label: 'Likes', value: totalLikes },
    { label: 'Comments', value: totalComments },
    { label: 'Shares', value: totalShares },
    { label: 'Total engagement', value: totalEngagements },
  ];

  return (
    <Table>
      <TableHeader>
        <TableRow
          className="border-b border-zinc-200 dark:border-zinc-700"
          gridTemplateColumns={gridTemplateColumns}
        >
          <TableHead className="h-12 px-4 text-sm font-medium text-zinc-500 dark:text-zinc-400">
            Metrics
          </TableHead>
          <TableHead className="h-12 w-31 px-4 text-sm font-medium text-zinc-500 dark:text-zinc-400">
            Volume
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {metrics.map((metric, index) => {
          const isLastRow = index === metrics.length - 1;

          return (
            <TableRow
              key={metric.label}
              className={`${isLastRow ? '' : 'border-b border-zinc-200 dark:border-zinc-700'} hover:bg-transparent`}
              gridTemplateColumns={gridTemplateColumns}
            >
              <TableCell
                className={`h-13 px-4 ${isLastRow ? 'text-base font-medium' : 'text-sm font-normal'} text-zinc-900`}
              >
                {metric.label}
              </TableCell>
              <TableCell
                className={`h-13 px-4 ${isLastRow ? 'text-base font-medium' : 'text-sm font-normal'} text-zinc-900`}
              >
                {formatNumber(metric.value)}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
